/**
 * inputCurrencyDirective
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function inputCurrencyDirective() {
    return {
        // language=HTML
        template: `
            <md-input-container md-no-float="noFloat">
                <label>{{ label }}</label>

                <input type="text"
                       name="{{ name || '' }}"
                       formatter-currency
                       placeholder="{{ placeholder || (0 | currency) }}"
                       ng-model="value"
                       ng-model-options="ngModelOptions"
                       ng-change="_onChange()"
                       ng-disabled="disabled"
                       ng-required="required"
                       min="{{ min }}"
                       max="{{ max }}"
                       step="{{ step }}">

                <div class="hint" ng-if="hint">
                    {{ hint }}
                </div>

                <div ng-if="form && name" ng-messages="form[name].$error">
                    <div ng-message="required">Required</div>
                    <div ng-message="custom">{{ form[name].customError }}</div>
                    <div ng-repeat="(key, message) in errorMessages" ng-message="{{ key }}">{{ message }}</div>
                </div>
            </md-input-container>
        `,
        scope: {
            allowInvalid: '=?allowInvalid',
            ngModelOptions: '=?ngModelOptions',
            onChange: '&change',
            disabled: '=ngDisabled',
            errorMessages: '=errorMessages',
            form: '=form',
            hint: '@?hint',
            label: '@label',
            max: '=?max',
            min: '=?min',
            name: '@name',
            noFloat: '=?noFloat',
            placeholder: '@?placeholder',
            required: '=?required',
            step: '=?step',
            value: '=value',
        },
        link: {
            pre: function preLink(scope, element, attrs) {
                element.addClass('app-form-field');

                scope._onChange = _onChange;

                // If it's undefined on the scope, it may mean that the attribute is there but
                // without content. If the attribute isn't undefined then we know it's been added.
                if (scope.required === undefined && attrs.required !== undefined) {
                    scope.required = true;
                }

                function _onChange() {
                    if (angular.isFunction(scope.onChange)) {
                        scope.onChange();
                    }

                    if (!scope.form || !scope.name) {
                        return;
                    }

                    if (scope.value) {
                        scope.form[scope.name].$setValidity('custom', true);
                        scope.form[scope.name].customError = null;
                    }
                }
            },
        },
    };
}
